import theme from '../theme'

export default (theme as any) as { [key: string]: any }
